import { useNavigate } from 'react-router';
import { useTranslation } from '../../../hooks/useTranslation';
import { CategoryDto } from '../../../commonTypes/documents.types';

interface ICard {
    category: CategoryDto;
    onDelete: (id: string) => void;
    documentCount: number;
}

export const Card = ({ category, onDelete, documentCount }: ICard) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const formatDocumentCount = (documentCount: number) => {
        if (documentCount === 1) return 'documents.document';
        if (documentCount > 1 && documentCount < 5) {
            return 'documents.documents';
        }
        return 'documents.documents2';
    };

    return (
        <div className="documents__card">
            <div className="documents__title">
                <h4 className="documents__name">{category.name}</h4>
                {category.name === 'General Documents' && (
                    <p className="documents__isMain documents__text--grey">({t('documents.defaultCategory')})</p>
                )}
            </div>
            <p className="paragraph-3">{category.description}</p>
            <div className="documents__columns">
                <p className="paragraph-3">
                    {documentCount} {t(formatDocumentCount(documentCount))}
                </p>
            </div>
            <div className="documents__actions">
                <button className="documents__button" onClick={() => navigate(`/category/${category.id}/edit`)}>
                    <img src="/svg/pen-grey.svg" alt="edit" />
                </button>
                {category.name !== 'General Documents' && (
                    <button className="documents__button" onClick={() => onDelete(category.id)}>
                        <img src="/svg/trash.svg" alt="delete" />
                    </button>
                )}
            </div>
        </div>
    );
};
